import styled from 'styled-components';

export const Link = styled.a`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-items: center;
`;
